import Crud from '../views/Group/Crud'
import Entity from '../views/Group/Add'

let routes = {
    path: '/groups',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/groups/add',
            name: 'NewGroup',
            component: Entity,
            meta: {
                perfil_id: ['1', '6'] // Administradores e gestores de empresa
            }
        },
        {
            path: '/groups/edit/:id?',
            name: 'EditGroup',
            component: Entity,
            meta: {
                perfil_id: ['1', '6', '7'] // Admin, Gestor da Empresa e Gestor Operacional (editar)
            }
        },
        {
            path: '/groups',
            name: 'list-groups',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Grupos',
                breadcrumb: [
                    {
                        text: 'Grupos',
                        active: true,
                    },
                ],
                perfil_id: ['1', '6', '7'] // Admin, Gestor da Empresa e Gestor Operacional (listar/editar)
            },
        },
    ]
};


export default routes
